import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import { useGetSelectedWorkspace } from './workspace';

const selectWorkspaces = state => state.workspace.workspaces;
const selectWorkspaceIdToCheck = (state, workspaceIdToCheck) =>
  workspaceIdToCheck;

const selectWorkspaceLimits = createSelector(
  [selectWorkspaces, selectWorkspaceIdToCheck],
  (workspaces, workspaceIdToCheck) => {
    return workspaces.find(ws => ws.id === workspaceIdToCheck)?.limits;
  }
);

export const useWorkspaceLimit = (limitName, workspaceId = null) => {
  const selectedWorkspace = useGetSelectedWorkspace();
  const workspaceIdToCheck = workspaceId || selectedWorkspace.id;

  const allWorkspaceLimits = useSelector(state =>
    selectWorkspaceLimits(state, workspaceIdToCheck)
  );

  return limitName ? allWorkspaceLimits?.[limitName] : allWorkspaceLimits;
};
